import React from 'react';
import Navigation from "../../components/navigation";
import {Stack} from "@mui/material";
import {Outlet} from "react-router";
import {HELP_NAV_LINK} from "../../constants/helpNavLink";

const AppPolicymaker = () => {

    const navLinks = [
        {destination: "/IR", label: "IR"},
        {destination: "/PIR", label: "PIR"},
        {destination: "/ICR", label: "Requirements"},
        {destination: "/IIR", label: "IIRs"},
        {destination: "/products?filter=fintel", label: "FINTEL", activePrefixes: ["/products"]},
        {destination: "/raw", label: "Raw Intel"},
        {destination: "/charts", label: "Charts"},
        {destination: "/experts", label: "Experts"},
        {destination: "/feed", label: "Feeds"},
        {destination: "/kb", label: "KB"},
        {destination: "/workflow", label: "Workflow"},
        HELP_NAV_LINK,
    ]

    return (
        <Stack height={'100vh'} overflow={'hidden'}>
            <Navigation navLinks={navLinks}/>
            <Outlet/>
        </Stack>
    );
};

export default AppPolicymaker;